/* eslint-disable */
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var CType;
(function (CType) {
    CType["STRING"] = "STRING";
    CType["CORD"] = "CORD";
    CType["STRING_PIECE"] = "STRING_PIECE";
})(CType = exports.CType || (exports.CType = {}));
var Exposure;
(function (Exposure) {
    Exposure["PRIVATE"] = "PRIVATE";
    Exposure["INTERNAL"] = "INTERNAL";
    Exposure["PUBLIC"] = "PUBLIC";
})(Exposure = exports.Exposure || (exports.Exposure = {}));
var Format;
(function (Format) {
    Format["EMAIL"] = "EMAIL";
    Format["HOSTNAME"] = "HOSTNAME";
    Format["IPV4"] = "IPV4";
    Format["IPV6"] = "IPV6";
    Format["URI"] = "URI";
    Format["WEB_URL"] = "WEB_URL";
    Format["PHONE"] = "PHONE";
    Format["CREDIT_CARD"] = "CREDIT_CARD";
    Format["GUID"] = "GUID";
    Format["COUNTRY"] = "COUNTRY";
    Format["LANGUAGE"] = "LANGUAGE";
    Format["DECIMAL_VALUE"] = "DECIMAL_VALUE";
    Format["CURRENCY"] = "CURRENCY";
    Format["LANGUAGE_TAG"] = "LANGUAGE_TAG";
})(Format = exports.Format || (exports.Format = {}));
var IdempotencyLevel;
(function (IdempotencyLevel) {
    IdempotencyLevel["IDEMPOTENCY_UNKNOWN"] = "IDEMPOTENCY_UNKNOWN";
    IdempotencyLevel["NO_SIDE_EFFECTS"] = "NO_SIDE_EFFECTS";
    IdempotencyLevel["IDEMPOTENT"] = "IDEMPOTENT";
})(IdempotencyLevel = exports.IdempotencyLevel || (exports.IdempotencyLevel = {}));
var JSType;
(function (JSType) {
    JSType["JS_NORMAL"] = "JS_NORMAL";
    JSType["JS_STRING"] = "JS_STRING";
    JSType["JS_NUMBER"] = "JS_NUMBER";
})(JSType = exports.JSType || (exports.JSType = {}));
var Label;
(function (Label) {
    Label["LABEL_OPTIONAL"] = "LABEL_OPTIONAL";
    Label["LABEL_REQUIRED"] = "LABEL_REQUIRED";
    Label["LABEL_REPEATED"] = "LABEL_REPEATED";
})(Label = exports.Label || (exports.Label = {}));
var Maturity;
(function (Maturity) {
    Maturity["ALPHA"] = "ALPHA";
    Maturity["BETA"] = "BETA";
    Maturity["IA"] = "IA";
    Maturity["GA"] = "GA";
})(Maturity = exports.Maturity || (exports.Maturity = {}));
var OptimizeMode;
(function (OptimizeMode) {
    OptimizeMode["SPEED"] = "SPEED";
    OptimizeMode["CODE_SIZE"] = "CODE_SIZE";
    OptimizeMode["LITE_RUNTIME"] = "LITE_RUNTIME";
})(OptimizeMode = exports.OptimizeMode || (exports.OptimizeMode = {}));
var Type;
(function (Type) {
    Type["TYPE_DOUBLE"] = "TYPE_DOUBLE";
    Type["TYPE_FLOAT"] = "TYPE_FLOAT";
    Type["TYPE_INT64"] = "TYPE_INT64";
    Type["TYPE_UINT64"] = "TYPE_UINT64";
    Type["TYPE_INT32"] = "TYPE_INT32";
    Type["TYPE_FIXED64"] = "TYPE_FIXED64";
    Type["TYPE_FIXED32"] = "TYPE_FIXED32";
    Type["TYPE_BOOL"] = "TYPE_BOOL";
    Type["TYPE_STRING"] = "TYPE_STRING";
    Type["TYPE_GROUP"] = "TYPE_GROUP";
    Type["TYPE_MESSAGE"] = "TYPE_MESSAGE";
    Type["TYPE_BYTES"] = "TYPE_BYTES";
    Type["TYPE_UINT32"] = "TYPE_UINT32";
    Type["TYPE_ENUM"] = "TYPE_ENUM";
    Type["TYPE_SFIXED32"] = "TYPE_SFIXED32";
    Type["TYPE_SFIXED64"] = "TYPE_SFIXED64";
    Type["TYPE_SINT32"] = "TYPE_SINT32";
    Type["TYPE_SINT64"] = "TYPE_SINT64";
})(Type = exports.Type || (exports.Type = {}));
